var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmilkeeper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7343_56282)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.00183,
    r: 8,
    fill: "url(#paint0_linear_7343_56282)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.30548C1.50503 8.31393 1.51042 8.32292 1.51618 8.33241C1.54034 8.37226 1.57098 8.42127 1.60829 8.47813C1.68276 8.5916 1.78467 8.73766 1.91552 8.90515C2.17567 9.23814 2.55993 9.66831 3.08206 10.0967C4.14251 10.9668 5.7736 11.8252 7.99142 11.8252C10.2092 11.8252 11.8403 10.9668 12.9008 10.0967C13.4229 9.66831 13.8072 9.23814 14.0673 8.90515C14.1982 8.73766 14.3001 8.5916 14.3746 8.47813C14.4119 8.42127 14.4425 8.37226 14.4667 8.33241C14.4787 8.31248 14.4892 8.2948 14.4981 8.27955L14.5 8.27631L10.5605 6.00183C10.5447 6.02492 10.5193 6.06066 10.4841 6.10573C10.389 6.22745 10.2332 6.40357 10.0165 6.58144C9.59908 6.9239 8.9566 7.27808 7.99142 7.27808C7.02624 7.27808 6.38376 6.9239 5.96639 6.58144C5.7496 6.40357 5.59389 6.22745 5.49879 6.10573C5.47556 6.076 5.45659 6.05032 5.44183 6.02967L1.5 8.30548Z",
    fill: "url(#paint1_linear_7343_56282)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7343_56282",
    x1: 16,
    y1: 8.00183,
    x2: 0,
    y2: 8.00183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0080CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7343_56282",
    x1: 3.5,
    y1: 6.00183,
    x2: 12.5,
    y2: 6.00183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7343_56282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.00183105)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilkeeper);
export default __webpack_public_path__ + "static/media/smilkeeper.eaf1f53ff0df79ec91a2157205a9f032.svg";
export { ForwardRef as ReactComponent };